import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useReportTypes} from '../hooks/useReportTypes';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useReportTypes();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
